import styled from 'styled-components';

export type FieldWrapperProps = {
  $isDisabled?: boolean;
  $isInvalid?: boolean;
};

export const FieldWrapper = styled.div<FieldWrapperProps>`
  border: 1px solid;
  border-color: ${({theme, $isInvalid}) =>
    $isInvalid ? theme.colors.severity.danger : theme.colors.palettes.neutral[70][100]};
  border-radius: ${({theme}) => theme.getSize(1)};
  background-color: ${({theme, $isDisabled}) =>
    $isDisabled ? theme.colors.palettes.white[10][40] : theme.colors.palettes.white[10][100]};
  overflow: hidden;

  &:focus-within {
    border-color: ${({theme, $isDisabled, $isInvalid}) =>
      $isDisabled
        ? theme.colors.palettes.neutral[70][40]
        : $isInvalid
          ? theme.colors.severity.danger
          : theme.colors.severity.informational};
    box-shadow: ${({theme, $isDisabled, $isInvalid}) =>
      $isDisabled || $isInvalid ? 'none' : theme.shadows.active};
  }
`;
